import { useRouter } from 'next/router'
import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { isAndroidApp, isDesktop, isMobile } from '../../../client'
import { usePage } from '../../../contexts'
import {
  IGridVodItem,
  isGridVodPage,
  isLiveVodPage,
  isVodPlaylist,
} from '../../../types'
import { AdCloseIcon, Container, InboardContainer } from './TopBanner.styles'
import { useUserInactivity } from '../../../contexts/hooks/useUserInactivity'
import { playerConfig } from '../../Player/Helpers'
import { Ad } from '../../../sharedComponnets'

interface TopBannerProps {
  isVod?: boolean
}

export const TopBanner = ({ isVod }: TopBannerProps) => {
  const page = usePage()
  const { asPath } = useRouter()

  if (
    (page?.Content?.PageGrid &&
      isVodPlaylist(page?.Content?.PageGrid[0] as IGridVodItem)) ||
    isGridVodPage(page)
  ) {
    return null
  }

  return (
    <TopBannerComp
      key={'TopBannerComp' + asPath}
      isLive={isLiveVodPage(page)}
      isVod={isVod}
    />
  )
}
export default TopBanner

interface TopBannerCompProps {
  isLive?: boolean
  isVod?: boolean
}

const sessionKey = 'renderFirstAd'

export interface IAdId {
  first: false | 'Inboard' | 'Maavaron_main'
  second: 'Top' | 'Top_mobile'
}

const TopBannerComp = ({ isLive, isVod }: TopBannerCompProps) => {
  const [adId, setAdId] = useState<IAdId | false>(false)
  const [renderButton, setRenderButton] = useState(false)
  const page = usePage()
  const { pageType, haseWarComp } = useMemo(() => {
    return {
      pageType: page?.PageMeta?.applicationPageType || '',
      haseWarComp: !!page?.PageMeta?.war_comp,
    }
  }, [page])

  const containerRef = useRef<HTMLImageElement>(null)

  const router = useRouter()

  const inactiveFor30min = useUserInactivity(playerConfig.INACTIVE_TIMEOUT)

  useEffect(() => {
    if (!adId || !adId.first) {
      return
    }

    if (inactiveFor30min) {
      sessionStorage.removeItem(sessionKey)
    }
  }, [adId, inactiveFor30min])

  useEffect(() => {
    const renderFirstOnMobile =
      isMobile() && !sessionStorage.getItem(sessionKey)
    sessionStorage.setItem(sessionKey, 'true')
    const renderFirst = isDesktop() || isAndroidApp() || renderFirstOnMobile
    if (isMobile()) {
      setAdId({
        first: renderFirst ? 'Maavaron_main' : false,
        second: 'Top_mobile',
      })
    } else {
      setAdId({ first: renderFirst ? 'Inboard' : false, second: 'Top' })
    }
  }, [router.asPath])

  useEffect(() => {
    const onRouteChangeStart = () => {
      setRenderButton(false)
    }
    router.events.on('routeChangeStart', onRouteChangeStart)
    return () => {
      router.events.off('routeChangeStart', onRouteChangeStart)
    }
  }, [router.events])

  const onRender = useCallback(
    (event: googletag.events.SlotRenderEndedEvent) => {
      // If the ad unit does not fill render top ad
      if (event.isEmpty) {
        adId && setAdId({ ...adId, first: false })
      } else {
        setTimeout(() => setRenderButton(true), 1000)
      }
    },
    [adId]
  )

  // const onTopRender = (ev: googletag.events.SlotRenderEndedEvent) => {
  //     //prettyLog('TopBanner: 119', {s:ev.size})
  // }

  return (
    <Container
      key={'topbannercontainer'}
      ref={containerRef}
      className={
        adId != false ? (adId?.first || adId?.second || '') + '_container' : ''
      }
      theme={{
        haseWarComp,
        pageType,
        isLive: isLive,
        isVod: isVod,
        dfpIsBlocked: page.PageMeta?.ads.block.dfp,
      }}
    >
      {adId &&
        (adId.first ? (
          <InboardContainer key={'InboardContainer'}>
            {renderButton ? (
              <AdCloseIcon
                onClick={() => adId && setAdId({ ...adId, first: false })}
              />
            ) : null}
            <Ad id={adId.first} collapse={true} onRender={onRender} />
          </InboardContainer>
        ) : (
          <Ad id={adId.second} collapse={true} />
        ))}
    </Container>
  )
}
